import {
  Menu,
  MenuOptions,
  MenuTrigger,
  renderers,
} from 'react-native-popup-menu'

interface MenuProps {
  children: React.ReactNode
  menuRef: React.MutableRefObject<Menu | null | undefined>
  onCloseRatingMenu(): void
}

export function RatingMenu({
  children,
  menuRef,
  onCloseRatingMenu,
}: MenuProps) {
  return (
    <Menu
      renderer={renderers.SlideInMenu}
      ref={ref => {
        menuRef.current = ref
      }}
      onClose={() => {
        onCloseRatingMenu()
      }}
    >
      <MenuTrigger />
      <MenuOptions>{children}</MenuOptions>
    </Menu>
  )
}
